import React from 'react';

import { Helmet } from 'react-helmet';

import { PROJECT } from './constants';

import Header from './components/Header';
import TopIntro from './components/TopIntro';
import KeyFeature from './components/KeyFeature';
import IntroVideo from './components/IntroVideo';
import GetStart from './components/GetStart';
import ScrollTopBtn from './components/ScrollTopBtn';
import Download from './components/Download';

function CreateLanding() {
  return (
    <div className="App create-landing">
      <Helmet>
        <link rel="icon" href={`favicon.ico?q=${Date.now()}`}/>
        <title>VIVE Create</title>
      </Helmet>
      <Header/>
      <div id='rows' className='rows'>
        <TopIntro/>
        <KeyFeature/>
        <GetStart/>
        <IntroVideo/>
      </div>
      <ScrollTopBtn/>
    </div>
  );
}

function GuardianLanding() {
  return (
    <div className="App vg-landing">
      <Helmet>
        <link rel="icon" href={`vg-icon.ico?q=${Date.now()}`}/>
        <title>VIVE Guardian</title>
      </Helmet>
      <Header/>
      <div id='rows' className='rows'>
        <TopIntro/>
        <KeyFeature/>
        <IntroVideo/>
        <Download/>
      </div>
      <ScrollTopBtn/>
    </div>
  );
}

const App = () => {
  switch(PROJECT){
    case 'create': 
      return <CreateLanding/>
    case 'vg':
      return <GuardianLanding/>
    default:
      return null;
  }
}

export default App;
